import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import Home from './home';
import HomeV4 from './home-v4';
import ReactGA from 'react-ga';

class App extends Component {
    setGA = () => {
        ReactGA.initialize('UA-110182129-1');
        ReactGA.pageview('Init page view');
    };

    componentDidMount() {
        this.setGA();
    };

    render() {
        return (
            <Route render={({ location }) =>
                location.pathname.endsWith('/tailwind-css-4') ? <HomeV4 /> : <Home />
            } />
        )
    }
}

export default App;
